import React, { useCallback, useMemo, useState } from "react";
import Typography from "@material-ui/core/Typography";
import { Box, makeStyles } from "@material-ui/core";
import VotingDialog from "./VotingDialog";
import { currentYear } from "../../../../../utils";
import {
  REPORT_ITEM_SUB_TYPE,
  REPORT_ITEM_TYPE
} from "../../../../../constants";
import CustomCardHeader from "../../CustomCardHeader";
import Button from "components/CustomButtons/Button";
import { Edit } from "@material-ui/icons";

const useStyles = makeStyles({
  actions: {
    margin: "0 0 0 5px",
    padding: 5,
    "& svg": {
      margin: 0
    }
  }
});
const ChapterBoardVotingInfo = ({
  reportID,
  chapterFinancial,
  updateVotingCount,
  onHelp,
  onRefetch,
  isEditable,
  chapterID,
  year,
  initialReportItems,
  onRedirect
}) => {
  const classes = useStyles();

  const [editDialogOpen, setEditDialogOpen] = useState(false);

  const getVotingMembers = useMemo(() => {
    return (
      (chapterFinancial &&
        chapterFinancial.report &&
        chapterFinancial.report.countVotingNumber) ||
      0
    );
  }, [chapterFinancial]);

  const onSave = useCallback(async value => {
    if (reportID === "add") {
      const _reportID = await initialReportItems({
        chapterID,
        year,
        countVotingNumber: +value
      });
      onRedirect(_reportID);
    } else {
      await updateVotingCount({
        id: +reportID,
        countVotingNumber: +value
      });
    }

    onRefetch();
    setEditDialogOpen(false);
  }, []);

  return (
    <Box mb={3}>
      <CustomCardHeader
        label={"Chapter Board Voting Information"}
        onHelp={() =>
          onHelp(REPORT_ITEM_TYPE.REVENUE, REPORT_ITEM_SUB_TYPE.VOTING_INFO)
        }
        extraContent={
          isEditable && (
            <Button
              simple
              color="primary"
              className={classes.actions}
              onClick={() => setEditDialogOpen(true)}
            >
              <Edit />
            </Button>
          )
        }
      />
      <Box display="flex" justifyContent="space-between" px={1} py={0.5}>
        <Typography style={{ fontSize: "14px" }}>
          Number of Board Members with Voting Rights at the end of the Current
          Fiscal Year
        </Typography>
        <Typography>{getVotingMembers}</Typography>
      </Box>

      <VotingDialog
        open={editDialogOpen}
        data={getVotingMembers}
        year={chapterFinancial ? chapterFinancial.year - 1 : currentYear}
        onSave={onSave}
        onClose={() => setEditDialogOpen(false)}
      />
    </Box>
  );
};

export default ChapterBoardVotingInfo;
